import * as React from 'react';
import { Link } from 'react-router-dom';
import { IconLogoSquareGoparrot } from '@goparrot-dashboard/shared-ui';

export const Logo = () => (
  <Link to="/dashboard" className="tw-flex">
    <IconLogoSquareGoparrot />
  </Link>
);
